"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TypeResolver =
/** @class */
function () {
  /**
  * Resolver used to create empty instance of object representing your content item.
  * For example if you create a class 'Character' which corresponds to 'character' code name of Kentico Cloud type, you
  * need to use TypeResolver like: 'new TypeResolver("code_example", () => new CodeExample())'
  * @constructor
  * @param {string} type - Codename of the content item defined in your Kentico Cloud content types
  * @param {() => ContentItem} resolve - Calbacked used to returs empty instance of proper item class
  */
  function TypeResolver(type, resolve) {
    this.type = type;
    this.resolve = resolve;
  }

  return TypeResolver;
}();

exports.TypeResolver = TypeResolver;